import React, { Fragment, useState } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/leis-auth.scss'
import Moment from 'moment';

const Contrato = (props) => {

    const inicioVigencia = Moment(props.contrato.inicioVigencia).utc(false).format("DD [de] MMMM [de] YYYY")
    const finalVigencia = Moment(props.contrato.finalVigencia).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataAssinatura = Moment(props.contrato.dataAssinatura).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataPub = Moment(props.contrato.dataPub).utc(false).format("DD [de] MMMM [de] YYYY")

    if (props.contrato.arquivos) {
        var urlContrato = `/transparencia${props.contrato.arquivos.contrato}`
        var urlTermo = `/transparencia${props.contrato.arquivos.termoAditivo}`
    }



    function renderButtons(props) {
        const buttons = [];

        if (props.contrato.anexos) {
            props.contrato.anexos.forEach((anexo, index) => {
                buttons.push(
                    <Fragment key={`anexo-${index}`}>
                        <a href={anexo.arquivo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">{anexo.nomeAnexo}</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            });
        }

        if (props.contrato.arquivos) {
            if (props.contrato.arquivos.contrato) {
                buttons.push(
                    <Fragment key="ata">
                        <a href={urlContrato} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Contrato</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }

            if (props.contrato.arquivos.termoAditivo) {
                buttons.push(
                    <Fragment key="ata">
                        <a href={urlTermo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Termo Aditivo</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            }
        }
        return buttons;
    }

    function anoProcesso() {
    var anoP;
    props.contrato.anoProcesso ? anoP = props.contrato.anoProcesso : anoP = props.contrato.ano;
    return anoP;
}

function anoContrato() {
    var anoC;
    props.contrato.anoContrato ? anoC = props.contrato.anoContrato : anoC = props.contrato.ano;
    return anoC;
}


    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>Contrato N° {props.contrato.numero}/{anoContrato()}</h5></Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <p><strong>Processo: </strong>{props.contrato.processo}/{anoProcesso()}</p>
                            <p><strong>Situação: </strong>{props.contrato.situacao}</p>
                            <p><strong>Objeto: </strong>{props.contrato.objeto}</p>
                            <p><strong>Vigência:</strong> {inicioVigencia} a {finalVigencia}</p>
                            <p><strong>Data de Assinatura: </strong>{dataAssinatura}</p>
                            {props.contrato.dataPub ? <p><strong>Data da Publicação: </strong>{dataPub}</p> : ''}
                            <p><strong>Contratante: </strong>{props.contrato.contratante}</p>
                            <p><strong>Contratado: </strong>{props.contrato.contratado}</p>
                            <p><strong>CNPJ: </strong>{props.contrato.cnpj}</p>
                            <p>Identificação: {props.contrato._id}</p>
                        </Card.Text>
                        {renderButtons(props)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Contrato;